// eslint-disable-next-line import/no-unresolved
require('./lib/initialize');



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/react-dates/initialize.js
// module id = 4286
// module chunks = 168707334958949